import fetchData from '@/service/fetch'
import api from '@/service/api'
import { Base64 } from 'js-base64'
import { getToken, setToken, removeToken } from '@/utils/auth'
import permission from './permission'
const user = {
  state: {
    token: getToken(),
    userInfo: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      if (userInfo) {
        localStorage.setItem('userName', userInfo['userName']) // 当前登陆用户昵称
        localStorage.setItem('acctName', userInfo['acctName']) // 当前登陆账号名
        localStorage.setItem('headUrl', userInfo['headUrl']) // 当前登陆账号名
      } else {
        localStorage.removeItem('userName')
        localStorage.removeItem('acctName')
        localStorage.removeItem('headUrl')
      }
    }
  },

  actions: {
    // 登录
    login({ commit }, params) {
      params.acctPwd = Base64.encode(params.acctPwd)
      return fetchData(api.login, params, 'post').then(res => {
        // commit('SET_USER_INFO', res)
        commit('SET_TOKEN', res.token)
        setToken(res.token)
        return res
      })
    },
    // 前端 登出
    logOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_USER_INFO', '')
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    checkHasPath({}, params) {
      return new Promise(async (resolve) => {
        // 如果当前路由不是需要配置权限的路由，则不判断直接让访问
        let flag = true;
        let totalMenus = localStorage.getItem("totalMenus")?JSON.parse(localStorage.getItem("totalMenus")):[];
        for (let v of totalMenus) {
          if (params == v) {
            flag = false
          }
        }
        if (!flag) {
          // 否则需要判断当前人是否又权限访问该路由
          if (permission.state.resMenus && permission.state.resMenus.length > 0) {
            for (let v of permission.state.resMenus) {
              if (params == v.url) {
                flag = true
              }
            }
          } else {
            await fetchData(api.getUserPermissions).then(res => {
              // flag = true
              for (let v of res) {
                if (params == v.url) {
                  flag = true
                }
              }
            })
          }
        }
        resolve(flag)
      })
    }
  }
}

export default user
